export function canUseLocalstorage() {
  try {
    localStorage.getItem("foo");
    return true;
  } catch {
    //console.log("localstorage is not available")
    return false;
  }
}
